var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Turnout from './Turnout';
import NotFound from './NotFound';
var RouteTeller = function RouteTeller(_ref) {
  var Exact = _ref.exact,
    routes = _ref.routes,
    root = _ref.root;
  var _useRouteMatch = useRouteMatch(),
    url = _useRouteMatch.url,
    path = _useRouteMatch.path;
  return React.createElement(Switch, null, Exact && React.createElement(Route, {
    exact: true,
    path: url
  }, React.createElement(Exact, null)), routes && routes.map(function (r) {
    return React.createElement(Turnout, _extends({
      key: r.path
    }, r, {
      path: root ? r.path : path + '/' + r.path
    }));
  }), React.createElement(Route, {
    path: '*'
  }, React.createElement(NotFound, {
    isRoute: true
  })));
};
RouteTeller.propTypes = {
  exact: PropTypes.func,
  routes: PropTypes.arrayOf(),
  root: PropTypes.bool
};
RouteTeller.defaultProps = {
  exact: undefined,
  routes: undefined,
  root: false
};
export default RouteTeller;